import { render, staticRenderFns } from "./shopProductsForm.vue?vue&type=template&id=c692cc92"
import script from "./shopProductsForm.vue?vue&type=script&lang=js"
export * from "./shopProductsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports